<template>
    <el-drawer
        :title="formData.id ? '编辑类别' : '新增类别'"
        :visible.sync="visible"
        :wrapperClosable="false"
        size="auto"
        @closed="closed"
    >
        <div class="drawer-content">
            <el-form :model="formData" :rules="rules" ref="formData" label-position="top" >
				<!-- <el-form-item label="选择类别:" prop="showTypeTagId" >{{formData.styleTagIds}}
					<el-cascader clearable multiple v-model="formData.styleTagIds" :options="showTypeTagList" :props="{value:'id',label:'name',children:'tags',emitPath:true}" placeholder="不限制活动类型" size="small" style="width:100%"></el-cascader>
					<el-cascader v-model="formData.showTypeTagId" :options="showTypeTagList" :props="{value:'id',label:'name',children:'tags', emitPath:false}" placeholder="请选择活动类型" size="medium" style="width:100%"></el-cascader>
				</el-form-item> -->
				<template v-if="formData.id">
					<el-form-item prop="position" label="选项层级位置:">
						{{formData.styleTagView}}
					</el-form-item>
				</template>
				<template v-else>
					<el-form-item prop="styleTagIds" label="活动类型:">
					    <el-cascader v-model="formData.styleTagIds" :options="showTypeTagList" :props="{value:'id',label:'name',children:'tags', emitPath:false, multiple:true,checkStrictly:true}" placeholder="请选择活动类型" size="medium" style="width:100%"></el-cascader>
					</el-form-item>
				</template>				
                <el-form-item prop="alias" label="别名:">
                    <el-input v-model="formData.alias" placeholder="请填写" size="medium" :maxlength="20"></el-input>
					<small><span class="color-warning">如果填写了别名，乐迷端将会以别名显示当前类别<br>如果聚合了多个系统选项，则必须填写别名</span></small>
                </el-form-item>
				<el-form-item prop="alias" label="选择图标:">
				    <div v-for="(item,index) in iconData" :key="index" class="img">
				        <el-image :src="item" fit="cover" :preview-src-list="iconData.map(v => v)">
				            <div slot="error" class="image-slot">
				                <i class="el-icon-picture-outline"></i>
				            </div>
				        </el-image>
				        <div class="tool">
				            <el-button icon="el-icon-delete" type="text" @click="del(item.id)" size="mini"></el-button>
				        </div>
				    </div>
					<canvas class="canvas" id="pag"></canvas>
				</el-form-item>
                <el-form-item prop="sort" label="置顶序位:">
                    <el-input v-model="formData.sort" placeholder="请填写" size="medium" :maxlength="40" ></el-input>
					<small><span class="color-warning">优先展示有序位的，按序位从小到大排列<br>其次展示无序位的，按活动数从多到少排列</span></small>					
                </el-form-item>               
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="visible = false">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="submitLoading">提交</el-button
            >
        </div>
    </el-drawer>
</template>

<script>
import { PAGInit } from 'libpag';
import { ref, computed, watchEffect, nextTick } from 'vue';
export default {
    data() {
        this.defaultFormData = {
            id: null,           
            styleTagIds: [],
            alias: null,
            sort: null
        }

        return {
            visible: false,
            formData: {
              ...this.defaultFormData 
            },
            rules: {                
                styleTagIds: { required: true, message: "请选择标签分类", trigger: 'change'},
                alias: { required: true, message: "请填写标别名", trigger: 'change'},
                sort: { required: true, message: "请填写置顶序位", trigger: 'change'}
            },
            submitLoading: false,
            showTypeTagList: [],
			position:1,
			iconData:[]
        };
    },
    created() {
        this.getShowTypeTag();
    },
    methods: {
        show(data) {
            this.formData = data
			// this.formData.styleTagIds = parseInt(this.formData.styleTagIds)
			console.log(typeof(this.formData.styleTagIds))
			// var styleIds = this.formData.styleTagIds.split(',').map(Number);
			// this.formData.styleTagIds = styleIds
			// console.log(styleIds)
            this.visible = true;
			this.getShowTypeTag();
			this.getIcon();
			
			
        },
		 async playPAG() {
		             
		},
        closed() {
            this.formData = {...this.defaultFormData};            
            this.$nextTick(() => {
                this.$refs['formData'].clearValidate();
            });
        },
        //获取活动类型
        getShowTypeTag() {
            this.$request({
                url: "/styleTag/showType/all",
                method: "post",
                params: { isAll: 1 }
            }).then(res => {
                const { state, result } = res.data;
                if (state == 1) {
                    this.showTypeTagList = result || []
					console.log(this.showTypeTagList)
                }
            })
        },
		getIcon(){
			this.$request({
				url: "/home/event/icon",
				method: "post",
				
			}).then(res => {
				const { state, result } = res.data;
				if (state == 1) {
					this.iconData = result
				}
			})
		},
		
        // 表单提交
        submitForm() {
            this.$refs["formData"].validate(async (valid) => {
                if(!valid) {
                    return ;
                }

                const res = await this.$request({
                    url: '/home/manage/edit',
                    method: 'post',
                    data: {...this.formData,styleTagIds:this.formData.styleTagIds.toString()}
                }).catch(() => {
                    return {data: {state: '0', msg: '请求错误'}};
                });

                const { state, msg} = res.data;

                if(state !== '1') {
                    return this.$message.error(msg || '请求失败');
                }
                
                this.visible = false;
                this.$emit('submitSuccess');

            });
        },
    },
};
</script>
<style lang="scss" scoped>
.img{
    border:1px $--color-border-gary solid;
    padding: 5px;
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    position: relative;
    background: #ffffff;
    margin: 5px;
    .el-image{
        width: 100%;
        height: 100%;
    }
    .tool{
        display: none;
        position: absolute;
        right: 0;
        top: 0;
        background: #ffffff;
        height: 26px;
        width: 26px;
        text-align: center;
        border-radius: 4px;
        .el-button{
            height: 26px;
        }
    }
    &:hover{
        .tool{
            display: block;
        }
    }
}

</style>